import { IAppUser } from "../models/IAppUser";

let user: IAppUser = {Id: -1};

export function currentUser(): IAppUser {
    user = {Id: -1};
    
    if (sessionStorage.getItem('AppUser')) {
        // Retrieving data from SessionStorage
        user = JSON.parse(sessionStorage.getItem('AppUser') as string);
    }

    return user;
}

export function logoutUser(): void {
    user = {Id: -1};

    // Removing data from SessionStorage
    sessionStorage.removeItem('AppUser');
}

export function setActiveUser(user: IAppUser): void {
    // Storing data in SessionStorage
    sessionStorage.setItem('AppUser', JSON.stringify(user));
}

export function isAuthenticated(): boolean {
    return sessionStorage.getItem('AppUser') != null;
}

export default user;